import type { JSX } from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

import ResetSvg from "@/assets/svgs/reset.svg?react";

/**
 * HIWIN reset icon.
 *
 * Aliased in vite.config.mts over @mui/icons-material Refresh / RestartAlt /
 * Restore so every reset action - ours and the renderer framework's - uses it.
 */
export default function ResetIcon(props: SvgIconProps): JSX.Element {
  return <SvgIcon component={ResetSvg} inheritViewBox {...props} />;
}
